/**
 * Generate an RFC 9562 UUIDv7 from the current Unix-millisecond timestamp and
 * cryptographically secure random bits. Ordering within one millisecond is
 * deliberately unspecified; Rekor only requires a valid, fresh UUIDv7 for a
 * seed-lease id (released ids are permanently burned, so freshness is the whole
 * requirement — monotonicity buys nothing).
 */
import { bytesToUuid, setUuidVersion } from './uuid-bytes';

export function uuidV7(): string {
  const now = Date.now();
  if (!Number.isSafeInteger(now) || now < 0 || now > 0xffffffffffff) {
    throw new RangeError('UUIDv7 timestamp must fit in 48 unsigned bits');
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // Big-endian 48-bit Unix-ms timestamp in bytes 0-5.
  let timestamp = now;
  for (let index = 5; index >= 0; index--) {
    bytes[index] = timestamp % 256;
    timestamp = Math.floor(timestamp / 256);
  }

  return bytesToUuid(setUuidVersion(bytes, 7));
}
